import script from "./Sprachtechnik-Ebics.vue?vue&type=script&setup=true&lang=js"
export * from "./Sprachtechnik-Ebics.vue?vue&type=script&setup=true&lang=js"

import "./Sprachtechnik-Ebics.vue?vue&type=style&index=0&id=50f346a4&lang=scss&scoped=true"
import "./Sprachtechnik-Ebics.vue?vue&type=style&index=1&id=50f346a4&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-50f346a4"]])

export default __exports__